import AContainer from "../../library/ExtendedObjects/AContainer.js";
import gameData from "../../gameData.js";
import Utils from "../../library/Utils.js";
import { Images } from "@abcya/abcya_phaser";

export default class EmojiArea extends AContainer
{
    constructor(scene, parent, x)
    {
        super(scene, x);

        this.sendArea = parent;
        this.emojiAreas = [];
        this.numEmojis_X = 4;
        this.numEmojis_Y = 2;
        let bgSize_Width = 180;
        let bgSize_Height = 136;
        let spacing_Y = 10;
        let spacing_X = 10;
        let totalWidth = ((bgSize_Width + spacing_X) * this.numEmojis_X);
        let offsetX = ((this.scene.size.width - totalWidth) * .5) + (spacing_X * .5);
        for (let y = 0; y < this.numEmojis_Y; y++) {
            for (let x = 0; x < this.numEmojis_X; x++) {
                let rect = this.scene.createRect(-bgSize_Width * .5, -bgSize_Height * .5, bgSize_Width, bgSize_Height, 0x99bbbb);
                let emojiGroup = this.scene.add.container((x * (bgSize_Width + spacing_X)) + offsetX + (bgSize_Width * .5), spacing_Y + (y * (bgSize_Height + spacing_Y)) + (bgSize_Height * .5), rect);
                this.emojiAreas.push(emojiGroup);
            }
        }

        this.add(this.emojiAreas);
        this.curEmoji_NearSubmit = false;

        this.scene.input.on('pointerup', ()=>{
            if(this.curEmoji == null) return;

            let image = this.curEmoji;
            let emojiIndex = this.submittedEmojis.indexOf(image);

            if(this.curEmoji_NearSubmit)
            {
                if (emojiIndex == -1) {
                    this.submittedEmojis.push(image);
                }
                else if ((new Date().getTime() - this.curEmoji.timeStamp) < 200) {
                    this.submittedEmojis.splice(emojiIndex, 1);
                    this.removeEmojiFromSubmit(image);
                }
            }
            else
            {
                if (emojiIndex != -1) {
                    this.submittedEmojis.splice(emojiIndex, 1);
                }

                if ((new Date().getTime() - this.curEmoji.timeStamp) < 200 && emojiIndex == -1) {
                    this.submittedEmojis.push(image);
                }
                else {
                    this.removeEmojiFromSubmit(image);
                }
            }

            this.curEmoji = null;
            this.alignEmojis();
            this.checkSubmittedEmojis();
        });

        this.emojiImages = [];
        this.submittedEmojis = [];

        this.emojis = gameData.emojis;
    }

    alignEmojis()
    {
        let spacing = 30;
        let textfieldPos = Utils.StagePos(this.sendArea.textField);
        let posX = textfieldPos.x - 40;

        for(let i = 0; i < this.submittedEmojis.length; i++)
        {   
            let emoji = this.submittedEmojis[i];
            let width = emoji.width * .5;
            this.scene.killTween(emoji);
            this.scene.addTween(emoji, 500, {x: posX + (width * .5), y: textfieldPos.y, scaleX: .6, scaleY: .6, easeParams: [0.8]}, "Back");
            posX += width + spacing;
        }
    }

    checkSubmittedEmojis()
    {
        let canAddMore = (this.submittedEmojis.length >= 4) ? false : true;
        for(let i = 0; i < this.emojiImages.length; i++)
        {
            if(this.submittedEmojis.indexOf(this.emojiImages[i]) != -1) continue;
            if (canAddMore) {
                this.emojiImages[i].tint = 0xffffff;
                this.emojiImages[i].setInteractive();
            } else {
                this.emojiImages[i].tint = 0xaaaaaa;
                this.emojiImages[i].removeInteractive();
            }
        }
        this.sendArea.toggleCanSend(this.submittedEmojis.length != 0);
    }

    populateEmojis(correctEmojis, bannedEmojis)
    {
        for(let i = 0; i < this.emojiImages.length; i++)
        {
            this.emojiImages[i].destroy();
        }

        this.emojiImages = [];
        this.submittedEmojis = [];

        let randAreas = Utils.Shuffle(this.emojiAreas);
        let randEmojis = correctEmojis.concat(Utils.Shuffle(Utils.RemoveDuplicates(this.emojis, correctEmojis)));
        
        randEmojis = Utils.RemoveDuplicates(randEmojis, bannedEmojis);

        for(let i = 0; i < this.numEmojis_X * this.numEmojis_Y; i++)
        {
            let emojiArea = randAreas[i];
            let image;
            if(randEmojis[i] !== 'Dollar')
            {
              image = this.scene.addImage(0, 0, randEmojis[i]);
            }
            else
            {
              image = Images.addImage(0, 0, randEmojis[i], this.scene, Images.LOCALIZATION_ATLAS);
            }

            image.setInteractive();
            image.originalArea = emojiArea;

            emojiArea.add(image);
            this.emojiImages.push(image);
            image.on("pointerdown", ()=>{ this.imageSelected(image); });
        }
    }

    imageSelected(image)
    {
        this.scene.killTween(image);
        this.scene.playSound("click");
        
        this.prevPointerPos = {x: this.scene.input.x, y: this.scene.input.y};
        this.curEmoji = image;
        this.curEmoji.timeStamp = new Date().getTime();

        this.curEmoji_NearSubmit = false;
        let stagePos = Utils.StagePos(image);
        image.originalArea.remove(image);

        this.scene.addTween(image, 500, {scaleX: 1.5, scaleY: 1.5}, "Back");

        this.curEmoji.x = stagePos.x;
        this.curEmoji.y = stagePos.y;
        this.scene.add.existing(this.curEmoji);
    }

    removeEmojiFromSubmit(emoji, speed = 500)
    {
        let imageArea = emoji.originalArea;
        let areaPos = Utils.StagePos(imageArea);

        this.scene.killTween(emoji);
        this.scene.addTween(emoji, speed, { x: areaPos.x, y: areaPos.y, scaleX: 1, scaleY: 1, easeParams: [0.8] }, "Back", () => {
            emoji.setPosition(0, 0);
            imageArea.add(emoji);
        });
    }

    removeEmojisFromSubmit()
    {
        let emojiNames = [];
        while(this.submittedEmojis.length > 0)
        {
            let emoji = this.submittedEmojis.shift();
            emojiNames.push(emoji.frame.customData.filename);
            this.removeEmojiFromSubmit(emoji, 10);
        }
        this.checkSubmittedEmojis();
        return emojiNames;
    }

    update()
    {
        if(this.curEmoji != null)
        {
            let moveDelta = {x: this.scene.input.x - this.prevPointerPos.x, y: this.scene.input.y - this.prevPointerPos.y};
            this.curEmoji.setPosition(this.curEmoji.x + moveDelta.x, this.curEmoji.y + moveDelta.y);
            this.prevPointerPos = {x: this.scene.input.x, y: this.scene.input.y};

            let inputAreaY = this.sendArea.inputArea.y;
            let inputAreaHeight = this.sendArea.textBg.height;

            if(this.curEmoji.y > (inputAreaY - (inputAreaHeight * .5)) && this.curEmoji.y < (inputAreaY + (inputAreaHeight * .5)) && !this.curEmoji_NearSubmit)
            {
                this.curEmoji_NearSubmit = true;
                
                this.scene.killTween(this.curEmoji);
                this.scene.addTween(this.curEmoji, 200, {scaleX: 1, scaleY: 1}, "Back");
            }
            else if((this.curEmoji.y < (inputAreaY - (inputAreaHeight * .5)) || this.curEmoji.y > (inputAreaY + (inputAreaHeight * .5))) && this.curEmoji_NearSubmit)
            {
                this.curEmoji_NearSubmit = false;

                this.scene.killTween(this.curEmoji);
                this.scene.addTween(this.curEmoji, 200, {scaleX: 1.5, scaleY: 1.5}, "Back");
            }
        }
    }
}